export interface IMedia {
  cite: string
  title: string
  date: string
  quote: string
  image: string
}

export const Media: IMedia[] = [
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-secures-70-million-in-series-c-funding-from-american-express-ventures-and-the-healthcare-of-ontario-pension-plan-300786971.html",
    title:
      "Better Mortgage Secures $70 Million in Series C Funding from American Express Ventures and the Healthcare of Ontario Pension Plan",
    date: "Jan 31, 2019",
    quote:
      " Better Mortgage, one of the leading digital mortgage lenders in the U.S., today announced its closing of $70 million in Series C financing from American Express Ventures and the Healthcare of Ontario Pension Plan (HOOPP), in addition to existing investors Kleiner Perkins, Goldman Sachs, and Pine Brook.",
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-expands-services-in-four-additional-states-300786750.html",
    title: "Better Mortgage Expands Services in Four Additional States",
    date: "Jan 30, 2019",
    quote:
      "Better Mortgage, one of the leading digital mortgage lenders in the U.S., today announced that it has launched services in four additional states: Alaska, Kentucky, Oklahoma and West Virginia.",
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-launches-emergency-refinance-program-to-help-government-workers-currently-furloughed-or-working-without-pay-300780029.html",
    title:
      "Better Mortgage Launches Emergency Refinance Program to Help Government Workers Currently Furloughed or Working without Pay",
    date: "Jan 17, 2019",
    quote:
      "Better Mortgage, one of the leading digital mortgage lenders in the U.S., today announced that it has launched a mortgage refinance program called Shutdown Relief Emergency Refi that allows federal employees to tap into their home equity for living expenses and delays loan payments for impacted federal government employees for up to 30 days after the end of the furlough.",
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-triples-loan-volume-in-2018-as-mortgage-industry-contracts-300779450.html",
    title:
      "Better Mortgage Triples Loan Volume in 2018 as Mortgage Industry Contracts",
    date: "Jan 16, 2019",
    quote:
      "Better Mortgage, one of the leading digital mortgage lenders in the U.S., today announced record-breaking 2018 results, including tripling mortgage originations, a doubling of its U.S. footprint as well as significant new talent gains. Better's growth significantly outperformed the mortgage industry which was adversely impacted by rising interest rates and a decrease in real estate sales volume.",
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-expands-services-in-eight-additional-states-300757470.html",
    title:
      "Better Mortgage is giving their borrowers an edge in competitive housing markets",
    date: "Nov 29, 2018",
    quote:
      "Better Mortgage, one of the leading digital mortgage lenders in the U.S., today announced that it has launched services in eight additional states: Alabama, Arkansas, Delaware, Kansas, Louisiana, Maine, North Dakota, and Wisconsin.",
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.wsj.com/articles/mortgage-rates-fast-approaching-5-a-fresh-blow-to-housing-market-1539266400",
    title: "Mortgage Rates Fast Approaching 5%, a Fresh Blow to Housing Market",
    date: "October 11, 2018",
    quote:
      '"There’s almost a generation that has been used to seeing 3% or 4% rates that’s now seeing 5% rates," said Vishal Garg, founder and chief executive of Better Mortgage.',
    image: "https://media.better.com/pages/about-us/media/color/wsj@2x.png",
  },
  {
    cite: "https://www.crainsnewyork.com/features/best-places-work-2018",
    title: "Best Places to Work 2018",
    date: "September 27, 2018",
    quote:
      '"Congratulations to the 100 companies that made our 10th annual list of the Best Places to Work in New York City. In partnership with Best Companies Group, Crain’s surveyed more than 20,000 employees..."',
    image: "https://media.better.com/content/prod/2018/10/BPTW-2018.jpg",
  },
  {
    cite:
      "https://www.chicagotribune.com/classified/realestate/ct-re-millennial-homeownership-20180902-story.html",
    title:
      "Rate of home ownership among black and Latino millennials is strikingly low, study finds",
    date: "August 27, 2018",
    quote:
      '"A recent study found millennials have lower homeownership rates than the nation’s two previous generations, and millennials of color have rates nearly 15 percentage points lower than their white counterparts..."',
    image:
      "https://media.better.com/content/prod/2018/09/chicago_tribune-1.jpg",
  },
  {
    cite: "https://www.businesswire.com/news/home/20180809005450/en/",
    title:
      "Better Mortgage Now Available in Iowa, Mississippi, and South Dakota",
    date: "August 9, 2018",
    quote:
      '"Better Mortgage, a digital mortgage company working to improve access to home financing for all Americans, is pleased to announce that it has launched its services in Mississippi, Iowa, and South Dakota..."',
    image:
      "https://media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.nbcnews.com/news/latino/millennials-especially-latinos-blacks-own-fewer-homes-wealth-gap-will-n890476",
    title:
      "As millennials, especially Latinos and Blacks, own fewer homes, wealth gap will grow",
    date: "July 11, 2018",
    quote:
      '"The report suggests several ways to promote home ownership among Millennials. One, says Vishal Garg, CEO of Better Mortgage, is to rethink current credit standards..."',
    image: "https://media.better.com/content/prod/2018/07/nbc%20news.png",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20180711005586/en/Mortgage-Launches-SpentOnRent-Increase-Awareness-Obstacles-Millennial",
    title:
      "Better Mortgage Launches #SpentOnRent to Increase Awareness of Obstacles to Millennial Homeownership",
    date: "July 11, 2018",
    quote:
      '"Millennials are not as involved in homeownership as prior generations. We encourage all Millennials to join the conversation... and tell us about why homeownership is important to you."',
    image:
      "https://media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20180711005491/en/MortgageUrban-Institute-Study-Reveals-Obstacles-Millennial-Homeownership",
    title:
      "Better Mortgage/Urban Institute Study Reveals Obstacles to Millennial Homeownership",
    date: "July 11, 2018",
    quote:
      '"Better Mortgage... chose the Urban Institute to conduct this research because of their phenomenal dedication to elevating the debate on social and economic policy."',
    image:
      "https://media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.fastcompany.com/40577659/too-broke-to-own-a-home-these-startups-will-fund-your-american-dream",
    title:
      "Too broke to own a home? These startups will fund your American Dream",
    date: "May 31, 2018",
    quote:
      '"For existing homeowners, there are now two new options... One is to refinance with help from Airbnb, which has teamed up with Quicken Loans, Citizens Bank, and Better Mortgage to ensure that hosts can include Airbnb Proof of Income in their application."',
    image:
      "https://media.better.com/content/prod/2018/07/fast_company_logo.png",
  },
  {
    cite:
      "https://www.benzinga.com/fintech/18/05/11743384/the-complete-list-of-the-2018-benzinga-global-fintech-award-winners",
    title:
      "The Complete List Of The 2018 Benzinga Global Fintech Award Winners",
    date: "May 18, 2018",
    quote:
      '"The Oscar-like event showcased the companies with the most impressive technology who are paving the future in financial services and capital markets."',
    image:
      "https://media.better.com/pages/about-us/media/color/logo-benzinga.png",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20180516005699/en/Tennessee-Homebuyers-Mortgage",
    title: "Tennessee Homebuyers Can Now Get a Better Mortgage",
    date: "May 16, 2018",
    quote:
      '"This launch comes as Better sees growing adoption amongst first-time homebuyers in popular metros, which cities like Nashville and Memphis have in spades due to growing employment opportunities (we see you, Amazon) and affordable starter home inventory."',
    image:
      "https://media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20180507005413/en/Mortgage-Hires-OnDeck-Chief-Financial-Officer",
    title: "Better Mortgage Hires Former OnDeck Chief Financial Officer",
    date: "May 7, 2018",
    quote:
      '"Better Mortgage, a digital mortgage company working to improve access to home financing through transparency, honest guidance and zero commissions, today announced that it has hired Howard Katzenberg as Chief Financial Officer."',
    image:
      "https://media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://money.cnn.com/2018/05/03/news/economy/housing-market-crash-mortgage/index.html",
    title: "The housing bust derailed his career. Here's what he's doing now",
    date: "May 3, 2018",
    quote:
      '"Personally, Hager said he has put the housing crash behind him. He is energized about working at a start up that focuses on helping home buyers, particularly first-timers, through the mortgage process."',
    image: "https://media.better.com/content/prod/2018/07/cnn_money.png",
  },
  {
    cite:
      "https://www.forbes.com/sites/alyyale/2018/05/01/putting-your-house-on-airbnb-what-to-know-before-hosting-as-a-homeowner/",
    title:
      "Putting Your House On Airbnb? What To Know Before Hosting As A Homeowner",
    date: "May 1, 2018",
    quote:
      '"According to Vishal Garg, CEO and founder of Better Mortgage, the program has seen big results since launching in February. \'As more and more Airbnb hosts are understanding that this is possible, we think this thing is gonna become really big."',
    image:
      "https://media.better.com/pages/about-us/media/color/logo-forbes.svg",
  },
  {
    cite:
      "https://knowledge.wharton.upenn.edu/article/banks-fintechs-adversaries-partners",
    title: "Banks and Fintechs: Adversaries or Partners?",
    date: "May 1, 2018",
    quote:
      '"According to Capgemini’s Krishnan, fintechs can take market share from banks “very quickly and often times without any signals to the big banks that they are losing market share.” He cites examples like PayPal, TransferWise, SoFi, Better Mortgage, Stripe, Square and Ant Financials. Paypal (digital payments firm) has over $450 billon of annual payments."',
    image: "https://media.better.com/content/prod/2018/07/wharton-logo.png",
  },
  {
    cite:
      "https://www.fatherly.com/love-money/this-company-wants-you-to-rethink-the-way-we-mortgage",
    title: "This Company Wants You to Rethink the Way We Mortgage",
    date: "Apr 30, 2018",
    quote:
      '"Garg believes those innovations will help buyers in their 20s and 30s avoid the same frustrations he had to endure. “They’re expecting a more modern mortgage experience than the one that’s available to them,” he says."',
    image: "https://media.better.com/content/prod/2018/07/fatherly_logo.png",
  },
  {
    cite:
      "https://www.nytimes.com/2018/04/23/opinion/racism-housing-market.html",
    title: "Letter to the Editor: Racism in the Housing Market",
    date: "Apr 23, 2018",
    quote:
      '"Lenders have a social responsibility they cannot ignore to turn the tide and stop financial racism in its tracks. We call on the lending industry to eliminate commissions, leverage technology to remove racial bias, and help more home buyers take advantage of affordable lending programs."',
    image:
      "https://media.better.com/content/prod/2018/09/newyork_times_logo.png",
  },
  {
    cite:
      "https://www.refinery29.com/2018/04/195456/what-to-do-if-youre-rejected-for-a-mortgage",
    title: "4 Steps To Take If You're Rejected For A Mortgage",
    date: "Apr 11, 2018",
    quote:
      "\"Figuring out what to do after a denial can be frustrating, since you likely won't be told why. \"Mortgage brokers and most banks don't tell you because they don't like to take the compliance risk of telling you the exact reason, and a lot of times, they don't even know because the systems don't talk to each other,\" says Vishal Garg, the founder and CEO of Better.com, a digital mortgage company.\"",
    image: "https://media.better.com/content/prod/2018/07/refinery_29_logo.png",
  },
  {
    cite:
      "https://www.forbes.com/sites/janetnovack/2018/02/13/the-forbes-fintech-50-for-2018",
    title: "The Forbes Fintech 50 For 2018",
    date: "Feb 13, 2018",
    quote:
      '"Better Mortgage has been named in the Forbes Fintech 50 for 2018 for its work in disrupting the future of lending and real estate investment/finance."',
    image:
      "https://media.better.com/pages/about-us/media/color/logo-forbes.svg",
  },
  {
    cite:
      "https://www.wsj.com/articles/gig-economy-grows-up-as-lenders-allow-airbnb-income-on-mortgage-applications-1518094800",
    title:
      "Gig Economy Grows Up as Lenders Allow Airbnb Income on Mortgage Applications",
    date: "Feb 8, 2018",
    quote:
      '"Vishal Garg, chief executive of Better Mortgage, said the program could be useful for empty nesters who rent out their children’s bedrooms and refinance to help pay for college tuition."',
    image: "https://media.better.com/pages/about-us/media/color/wsj@2x.png",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20180208005753/en/Mortgage-Airbnb-Launch-Initiative-Making-Refi-Option",
    title:
      "Better Mortgage and Airbnb Launch Initiative Making a Refi an Option for More People",
    date: "Feb 8, 2018",
    quote:
      '"Better Mortgage today announced the launch of a new initiative with Airbnb. Airbnb hosts who list their primary residence on Airbnb can now use that income to qualify for a refinance on that home, specifically."',
    image: "//media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.benzinga.com/fintech/18/01/11034963/better-mortgage-is-a-digital-home-loan-aimed-squarely-at-millennials",
    title:
      "Better Mortgage Is A Digital Home Loan Aimed Squarely At Millennials",
    date: "Jan 16, 2018",
    quote:
      '"By digitizing every step of the antiquated financing process, Better is working to improve access to home financing for a new generation of homeowners."',
    image: "//media.better.com/pages/about-us/media/color/logo-benzinga.png",
  },
  {
    cite:
      "https://www.nerdwallet.com/l/nerdwallets-best-of-winners/all#mortgages",
    title: "Best Online Mortgage Lender For Customer Service",
    date: "Jan 9, 2018",
    quote:
      "Better Mortgage has been named NerdWallet's Best Online Mortgage Lender For Customer Service.",
    image: "//media.better.com/pages/about-us/media/color/logo-nerdwallet.png",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20171214005350/en/Working-Mortgage-Means-Borrowers-Beat-Cash-Offers",
    title: "Working with Better Mortgage Means Borrowers Can Beat Cash Offers",
    date: "Dec 14, 2017",
    quote:
      '"Our appraisal panels make our digital company hyper local and help us level the playing field for first-time homeowners in communities where they want to put down roots. No other lender, local or otherwise, offers this option."',
    image: "//media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.wsj.com/articles/want-that-house-youd-better-pay-in-cash-1512469800",
    title: "Want That House? You’d Better Pay in Cash",
    date: "Dec 5, 2017",
    quote:
      '"The online lender Better Mortgage Corp. is testing a product that would underwrite mortgages within a day, allowing would-be buyers to better compete against cash offers. Company chief executive Vishal Garg started the company after he got outbid for his first home by a cash buyer several years ago."',
    image: "//media.better.com/pages/about-us/media/color/wsj@2x.png",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20171103005497/en/Mortgage-Adds-Real-Estate-Tech-Veteran-Jeff",
    title:
      "Better Mortgage Adds Real Estate Tech Veteran Jeff Corbett to Their Growing Team",
    date: "Nov 3, 2017",
    quote:
      "\"'I joined Better because of their attention to improving the entire mortgage process from the ground up, from qualification to close, for all parties in the transaction, internal and external,' says Corbett.\"",
    image: "//media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.forbes.com/sites/samanthasharf/2017/11/03/what-the-republican-tax-plan-means-for-the-value-of-your-home/#52603bfb3c4d",
    title: "What The Republican Tax Bill Means For The Value Of Your Home",
    date: "Nov 3, 2017",
    quote:
      "\"'This tax plan would turn America from a nation of property owners into a nation of tenants renting from private equity-backed landlords,' argues Vishal Garg, CEO of Better Mortgage, an online mortgage lender focused on Millennials. 'Why should corporate landlords get the deduction if your consumer homebuyer can't?\"",
    image: "//media.better.com/pages/about-us/media/color/logo-forbes.svg",
  },
  {
    cite:
      "https://www.businesswire.com/news/home/20171019006262/en/Mortgage-Companies-Utilize-New-Samsung-Rewards-API",
    title:
      "Better Mortgage Becomes One of the First Companies to Utilize the New Samsung Rewards API",
    date: "Oct 19, 2017",
    quote:
      '"By integrating with Samsung Reward’s API, [Better is] able to provide an even better customer experience to a new audience who wants to do everything from paying for coffee to buying a home right from their phone."',
    image: "//media.better.com/pages/about-us/media/color/businesswire.jpg",
  },
  {
    cite:
      "https://www.mortgageloan.com/fannie-mae-homeready-offers-low-down-payments-generous-credit",
    title: "Fannie Mae HomeReady offers low down payment, credit requirements",
    date: "Sep 5, 2017",
    quote:
      '"The methods are meant to help a generation of homebuyers — mainly Millennials — who have delayed buying a home for financial and other reasons and have different housing situations than their parents did."',
    image: "//media.better.com/pages/about-us/media/color/mortgage-loan.svg",
  },
  {
    cite:
      "https://www.forbes.com/sites/omribarzilay/2017/07/25/this-company-is-about-to-transform-the-1-5-trillion-mortgage-industry/#3c747ab27102",
    title:
      "This Company Is About To Transform The $1.5 Trillion Mortgage Industry",
    date: "Jul 25, 2017",
    quote:
      '"By moving to a digital model, we’ve increased the speed at which people can obtain mortgages, decreased the costs by removing friction, and leveled the playing field when it comes to home-buying."',
    image: "//media.better.com/pages/about-us/media/color/logo-forbes.svg",
  },
  {
    cite:
      "https://www.themuse.com/advice/19-companies-where-you-can-get-your-innovation-on/",
    title: "19 Companies Where You Can Get Your Innovation On",
    date: "July 12, 2017",
    quote:
      '"When it comes to ideas at Better, everybody’s input is not only welcomed—it’s encouraged. The company stresses that it’s not just about having the best idea, but it’s about actually making it happen."',
    image: "//media.better.com/pages/about-us/media/color/the-muse@2x.png",
  },
  {
    cite:
      "https://bankinnovation.net/2017/07/mortgage-lenders-should-take-hints-from-spotify/",
    title: "Mortgage Lenders Should Take Hints from Spotify",
    date: "Jul 6, 2017",
    quote:
      '"We’ve made it an online process — you walk into an open house, you pull out your phone, give us a few details, and we can approve you [for a loan] for that house while you are still in the house,” Garg said. “It takes the entire stress out of the home-buying process, because you already know whether you can afford it or not."',
    image:
      "//media.better.com/pages/about-us/media/color/bankinnovation@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-is-giving-their-borrowers-an-edge-in-competitive-housing-markets-300445656.html",
    title:
      "Better Mortgage is giving their borrowers an edge in competitive housing markets",
    date: "Apr 26, 2017",
    quote:
      'According to borrowers Bruno and Sabrina looking for a home in San Francisco, getting pre-approved with Better.com "really gave us a significant advantage over other buyers, the seller felt much more confident working with us." When asked about the experience, they added, "it\'s way more than a disruption, it\'s a r-e-v-o-l-u-t-i-o-n!"',
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.forbes.com/sites/truebridge/2017/04/24/how-better-mortgage-is-giving-control-back-to-homebuyers",
    title: "How Better Mortgage is Giving Control Back to Homebuyers",
    date: "Apr 24, 2017",
    quote:
      '"Better doesn’t just digitize the traditional mortgage process...it makes the process of financing the purchase of a home so easy and certain for buyers."',
    image: "//media.better.com/pages/about-us/media/color/logo-forbes.svg",
  },
  {
    cite: "https://www.huffingtonpost.com/entry/58f79185e4b0c892a4fb7477",
    title:
      "As the Lending Industry Awaits Regulation Changes, Innovators Move Full Steam Ahead",
    date: "Apr 19, 2017",
    quote:
      '"We can assure consumers the best price, so much so that we have the only rate guarantee in the industry, beating any valid competitor’s rate across every product by $1000, or we\'ll pay you $1000. No other lender has such a guarantee."',
    image: "//media.better.com/pages/about-us/media/color/huff-po.svg",
  },
  {
    cite:
      "https://www.mba.org/publications/insights/articles/featured-article/the-race-for-market-share-traditional-lenders-vs-digital",
    title: "The Race for Market Share: Traditional Lenders vs. Digital",
    date: "Apr 11, 2017",
    quote: '"We\'re going to serve the consumer better than anyone else."',
    image: "//media.better.com/pages/about-us/media/color/mba@2x.jpg",
  },
  {
    cite:
      "https://cheddar.vhx.tv/cheddar-archive/videos/cheddar-cheddar-life-s16-e032917-i-full-mezz-hd-en-us",
    title: "Better Mortgage CEO Vishal Garg interviewed on Cheddar TV",
    date: "Mar 29, 2017",
    quote:
      '"Better Mortgage is a digital platform that is helping take the confusion out of buying a home."',
    image: "//media.better.com/pages/about-us/media/color/cheddar@2x.png",
  },
  {
    cite:
      "https://www.inman.com/2017/03/20/new-lender-better-com-better-way-qualify-leads/",
    title: "Is new lender better.com a better way to qualify leads?",
    date: "Mar 20, 2017",
    quote: '"Agents can feel confident referring leads to the website."',
    image: "//media.better.com/pages/about-us/media/color/inman@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-secures-15-million-in-series-b-funding-from-kleiner-perkins-goldman-sachs-and-pine-brook-300404951.html",
    title:
      "Better Mortgage secures $15 million in Series B funding from Kleiner Perkins, Goldman Sachs, and Pine Brook",
    date: "Feb 09, 2017",
    quote:
      '"With over half a billion dollars in loans originated in our first year—more than any other fintech startup in its initial year of launch—consumers have confirmed that we are onto something extraordinary." -Vishal Garg, Founder and CEO of Better.',
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.wsj.com/articles/lender-better-mortgage-gets-new-kleiner-perkins-funding-valuing-firm-at-220-million-1486643386",
    title:
      "Lender Better Mortgage Gets New Kleiner Perkins Funding Valuing Firm at $220 Million",
    date: "Feb 09, 2017",
    quote:
      '"Online real estate lender Better Mortgage Inc. said Thursday that it has raised new money from Kleiner Perkins Caufield &amp; Byers in a deal that values the company at $220 million."',
    image: "//media.better.com/pages/about-us/media/color/wsj@2x.png",
  },
  {
    cite: "https://www.themuse.com/advice/19-companies-as-great-as-google",
    title: "19 Companies as Great as Google",
    date: "Dec 09, 2016",
    quote:
      '"Better Mortgage is a full-stack mortgage company connecting consumers directly to funders, speeding and simplifying the process to purchase or refinance a home."',
    image: "//media.better.com/pages/about-us/media/color/the-muse@2x.png",
  },
  {
    cite:
      "https://www.nationalmortgagenews.com/news/technology/build-vs-buy-takes-on-new-meaning-in-digital-mortgage-era-1092577-1.html",
    title: "Build vs. Buy Takes on New Meaning in Digital Mortgage Era",
    date: "Dec 09, 2016",
    quote:
      '"We had an assembly line like a Model T assembly line and we turned that into a Tesla so we could focus on the things that matter the most to the consumer and to the investors."',
    image:
      "//media.better.com/pages/about-us/media/color/national-mortgage-news@2x.png",
  },
  {
    cite:
      "https://www.ft.com/content/e83f9a78-b1bc-11e6-9c37-5787335499a0?ftcamp=crm/email//nbe/CompaniesBySector/product",
    title: "Fintech start-ups look to build on U.S. mortgage market share",
    date: "Nov 24, 2016",
    quote:
      '"Better is now producing about $65 million of loans a month through its online platform, flipping the loans on to about 20 investors including Fannie Mae, the government-backed mortgage company."',
    image: "//media.better.com/pages/about-us/media/color/ft@2x.png",
  },
  {
    cite: "https://www.alleywatch.com/2016/07/54392/",
    title:
      "This NYC Startup Just Raised $30M To Get You a Quote on Your Mortgage in Seconds",
    date: "Jul 19, 2016",
    quote:
      '"Getting a quote for a mortgage, whether it is for your first or refinancing your fifth house is not simple. Forgetting all the paper work and obnoxious phone calls you’ll have to make, you wont even know if you are getting the best quote. Thankfully, Better Mortgage is changing the game."',
    image: "//media.better.com/pages/about-us/media/color/alleywatch@2x.png",
  },
  {
    cite:
      "https://www.bizjournals.com/newyork/news/2016/06/14/lending-service-better-mortgage-secures-30m-series.html",
    title: "Lending service Better Mortgage secures $30M Series A",
    date: "Jun 27, 2016",
    quote:
      '"The company, based in Lower Manhattan, aims to simplify the transaction process consumers undertake when buying a new house."',
    image: "//media.better.com/pages/about-us/media/color/nybj@2x.png",
  },
  {
    cite:
      "https://www.prnewswire.com/news-releases/better-mortgage-secures-30-million-in-funding-from-goldman-sachs-pine-brook-kck-group-and-ia-ventures-300283576.html",
    title:
      "Better Mortgage Secures $30 Million In Funding From Goldman Sachs, Pine Brook, KCK Group, And IA Ventures",
    date: "Jun 13, 2016",
    quote:
      '"Better Mortgage offers transparency, simplicity, and affordability in an industry traditionally driven by paper and human processing."',
    image: "//media.better.com/pages/about-us/media/color/pr-newswire@2x.png",
  },
  {
    cite:
      "https://www.wsj.com/articles/online-lenders-secret-to-success-past-failure-1465723802",
    title: "Online Lender’s Secret to Success: Past Failure",
    date: "Jun 12, 2016",
    quote:
      '"Better Mortgage late last month was able to raise an additional $10 million in equity at a valuation of $110 million, a roughly 25% premium to what it was valued at last December."',
    image: "//media.better.com/pages/about-us/media/color/wsj@2x.png",
  },
  {
    cite:
      "https://chicagoinno.streetwise.co/2016/01/27/moderne-ventures-announces-first-full-class-of-startups-for-its-real-estate-accelerator/",
    title:
      "Moderne Ventures Announces First Full Class of Startups For Its Real Estate Accelerator",
    date: "Jan 27, 2016",
    quote:
      '"Better wants to change the process of getting a mortgage. Through its online platform, people can quickly get a rate quote and get pre-approved in under three minutes."',
    image: "//media.better.com/pages/about-us/media/color/chicagoinno@2x.png",
  },
]
